import React, { useCallback } from 'react';
import { FilterFormData } from '../stores/ui/uiStore';

interface FilterChipsProps {
  filters: FilterFormData | null;
}

const FilterChips: React.FC<FilterChipsProps> = ({ filters }) => {

  const generateFilterChips = useCallback(() => {
    if (!filters) return [];
    
    const chips: string[] = [];

    // 시간 필터 (커스텀 인풋이 있을 때만 표시)
    const hasCustomTimeRange = filters.customTimeMinutes && (filters.customTimeMinutes.min !== undefined || filters.customTimeMinutes.max !== undefined);
    if (hasCustomTimeRange && filters.customTimeMinutes) {
      const { min, max } = filters.customTimeMinutes;
      if (min !== undefined && max !== undefined) {
        chips.push(`First Buy Time: ${min}m ~ ${max}m`);
      } else if (min !== undefined) {
        chips.push(`First Buy Time: ${min}m ≤`);
      } else if (max !== undefined) {
        chips.push(`First Buy Time: ≤ ${max}m`);
      }
    }

    // Last Tx Time 시간 필터 (커스텀 인풋이 있을 때만 표시)
    const hasLastUpdatedCustomRange = filters.lastUpdatedCustomTimeMinutes && (filters.lastUpdatedCustomTimeMinutes.min !== undefined || filters.lastUpdatedCustomTimeMinutes.max !== undefined);
    if (hasLastUpdatedCustomRange && filters.lastUpdatedCustomTimeMinutes) {
      const { min, max } = filters.lastUpdatedCustomTimeMinutes;
      if (min !== undefined && max !== undefined) {
        chips.push(`Last Tx Time: ${min}m ~ ${max}m`);
      } else if (min !== undefined) {
        chips.push(`Last Tx Time: ${min}m ≤`);
      } else if (max !== undefined) {
        chips.push(`Last Tx Time: ≤ ${max}m`);
      }
    }


    // 각 필터 항목들
    const filterFields = [
      { key: 'currentAfCnt', label: 'Current AF Count' },
      { key: 'athAfCnt', label: 'ATH AF Count' },
      { key: 'atlMc', label: 'ATL MC', unit: 'K' },
      { key: 'athMc', label: 'ATH MC', unit: 'K' },
      { key: 'mc', label: 'Current MC', unit: 'K' },
      { key: 'currentTokenAmountInDecimals', label: 'Current Token Amount', unit: 'M' },
      { key: 'athTokenAmountInDecimals', label: 'ATH Token Amount', unit: 'M' },
      { key: 'totalUsedUsd', label: 'Total Used USD' },
      { key: 'devClusterCnt', label: 'Dev Cluster Count' },
      { key: 'cumulativeConvictionAtSameTimeRank', label: 'Rank' }
    ];

    filterFields.forEach(({ key, label, unit }) => {
      const filter = filters[key as keyof FilterFormData] as { min?: number; max?: number };
      if (filter && (filter.min !== undefined || filter.max !== undefined)) {
        let chipText = '';
        
        // 단위 변환 함수
        const formatValue = (value: number, unit?: string) => {
          if (!unit) return value.toString();
          if (unit === 'K') return (value / 1000).toFixed(0);
          if (unit === 'M') return (value / 1000000).toFixed(0);
          return value.toString();
        };
        
        if (filter.min !== undefined && filter.max !== undefined) {
          chipText = `${label}: ${formatValue(filter.min, unit)}${unit || ''} ≤ 𝑥 ≤ ${formatValue(filter.max, unit)}${unit || ''}`;
        } else if (filter.min !== undefined) {
          chipText = `${label}: ${formatValue(filter.min, unit)}${unit || ''} ≤ 𝑥`;
        } else if (filter.max !== undefined) {
          chipText = `${label}: 𝑥 ≤ ${formatValue(filter.max, unit)}${unit || ''}`;
        }
        
        if (chipText) {
          chips.push(chipText);
        }
      }
    });

    return chips;
  }, [filters]);

   if (!filters) return (
    <div className="h-[30px] overflow-x-auto scrollbar-hide mb-3">
    <div className="flex items-center space-x-2 px-4 py-1 min-w-full">
     
    </div>
  </div>
  );

  const chips = generateFilterChips();

  if (chips.length === 0) return null;

  return (
    <div className="h-[30px] overflow-x-auto scrollbar-hide mb-3">
      <div className="flex items-center space-x-2 px-4 py-1 min-w-full">
        {chips.map((chip, index) => (
          <div
            key={index}
            className="flex-shrink-0 px-2 py-1 bg-transparent border border-amber-500 text-amber-500 text-xs rounded-full whitespace-nowrap"
          >
            {chip}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterChips;
